<template>
    <el-dialog :title="$t('subnet.text.addSubCidr')" 
        :visible.sync="visible" @close="doClose"
        class="add-sub-cidr-container cps-dialog-icon-line-height"
        :close-on-click-modal="false">
        <el-form ref="form" :model="form" class="add-sub-cidr-form" label-width="150px" :rules="rules">
            <!--私有网络-->
            <el-form-item :label="$t('privateNetInstance.privateNet') | withColon">
                 <el-select v-model="vpcCidrValue" style="width:auto">
                      <el-option
                          v-for="item in availablePrivateNetworks"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
                    </el-option>
               </el-select>

                <!-- <span>{{detailData.vpcCidr}}</span> -->
            </el-form-item>
            <!--次要CIDR名称-->
            <el-form-item 
                :label="$t('subnet.text.subCidrName') | withColon" prop="name" required 
                :show-message="false">
                <el-input v-model="form.name" 
                    :placeholder="$t('subnet.help.enterSubCidrName')"
                    @blur="ruleFormTag.name = 1"
                    @focus="ruleFormTag.name = 0">
                </el-input>
                <p v-if="ruleFormTag.name !== 0 && form.name==''"
                    class="el-form-item-help-error">
                    {{$t('create.placeholder.nameNull')}}</p>
                <p v-else class="el-form-item-name-help"
                   :class="{'el-form-item-help-error': this.ruleFormTag.name === 'error'}">
                  {{$t('create.help.name')}}</p>
            </el-form-item>
            <!--次要CIDR-->
            <el-form-item :label="$t('subnet.text.subCidr') | withColon" prop="cidr" required :show-message="false">
                <el-input v-model="form.cidr" 
                    :placeholder="$t('subnet.help.enterSubCidr')" @blur="ruleFormTag.cidr=1" @focus="ruleFormTag.cidr=0">
                </el-input>
                <el-tooltip effect="dark" class="ml10" placement="right">
                    <div slot="content" class="my-create-tip">{{$t('subnet.help.onlyForCreateLocateIpAlias')}}</div>
                    <a><i class="jc-icon-question"></i></a>
                </el-tooltip>
                <p 
                    v-if="ruleFormTag.cidr !== 0 && form.cidr ===''"
                    class="el-form-item-help-error">
                    {{$t('create.placeholder.subCidrNameNull')}}
                </p>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
            <el-button @click="doConfirm" type="primary">{{ $t('detail.text.sure') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { ValidOrErrorConstant, CidrRuleConstant} from '@/common/Constants';
export default {
    data() {
        const nameInputValidator = (rule, value, callback) => {
            const nameRegex = new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$');
            if (!value) {
                this.ruleFormTag.name=1
                return callback(new Error(this.$t('subnet.help.aliasIpCannotBeNull')));
            }
            if (!nameRegex.test(value)) {
                this.ruleFormTag.name='error'
                return callback(new Error());
            }
            callback();
        };
        const cidrInputValidator = (rule, value, callback) => {
            if (this.open) {
                return
            }
            const ipRegex = CidrRuleConstant;
                if (!value) {
                    this.ruleFormTag.cidr = 1
                    return callback(new Error(this.$t('subnet.help.aliasIpCannotBeNull')));
                }
            if (!ipRegex.test(value)) {
                this.ruleFormTag.cidr = 'error'
                return callback(new Error(this.$t('subnet.help.cidrNotStandard')));
            }
            callback();
        };
        return {
            vpcCidrValue:'',
            rules: {
                name: [
                  {
                    trigger: 'blur',
                    validator: nameInputValidator,
                  }
                ],
                cidr: [
                  {
                    trigger: 'blur',
                    validator: cidrInputValidator
                  }          
                ]
            },
            ruleFormTag: {
                name: 0,
                cidr: 0
            },
            form: {
                name: '',
                cidr: ''
            },
            visible: this.dialogVisible
        };
    },
    props: {
        // 子网详情数据
        detailData: {
            type: Object
        },
        // 是否显示
        dialogVisible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        dialogVisible(newVal) {
            this.visible = newVal;
        }
     },
    computed: {
        ValidOrErrorConstant: () => ValidOrErrorConstant,

        availablePrivateNetworks(){
            let Cidroption={
                value: '',
                label:'VPC IPv4 CIDR'+ ' ('+this.detailData.vpcCidr+')'
            }
            let list=[];
            list.push(Cidroption)
            return list
        }
        
    },
    
  methods: {
    // 取消
    doClose() {
        this.$emit('update:dialogVisible', false);
        this.$refs['form'].resetFields();
        this.ruleFormTag = {
            name: 0,
            cidr: 0
        };
    },
    // 确定
    doConfirm() {
        let isValid = this.checkValid();
        if(!isValid) {
            return
        }
        this.addSubCidr();
    },
    checkValid() {
        let initValid = true;
        this.$refs['form'].validate((valid) => {
            initValid = initValid && valid;
            if (!valid) {
                return false;
            }
        });
        return initValid
    },

    
    // 添加次要CIDR
    addSubCidr() {
        const params = Object.assign(this.form, {
            region: this.detailData.region,
            subnetId: this.detailData.subnetId,
            clientToken: Normal.getClientToken()
        });
        Ajax.put('/api/cps/secondaryCidrs', params)
        .then(() => {
          // 操作成功提示
          this.$emit('refreshSubCidrListData');
        })
        .catch(async (err) => {
            const { response } = err.data;
            try {
                const json = await response.json();
                this.$message.error(json.errmsg);
            } catch (ex) {
                console.log(ex);
            }
        })
        .finally(() => {
            this.doClose();
        });
    }
  },

};
</script>

<style lang="scss">
    .add-sub-cidr-container{
        .add-sub-cidr-form {
            .el-input {
                width: 320px !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/subnet/addSubCidr/AddSubCidr.vue